import AllAppsCentre from "../components/AllAppsCentre"

const Home = (props) => {
    return (
        <AllAppsCentre 
            username={props.username} 
            loginList={props.loginList} 
            isActive={props.isActive}
            grievancePermission={props.grievancePermission} 
        />
    )
}

export default Home
